import { ApiClient, JwtAuthenticatedApiClient } from '@guiker/background-check-shared'
import { useAuthenticatedApiClient, useJwtAuthenticatedApiClient } from '@guiker/react-framework'

export const useBackgroundCheckApiClient = useAuthenticatedApiClient(ApiClient)
export const useJwtBackgroundCheckApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
